<div
  *ngIf="!!environment?.mostrar_esteira_desenvolvimento && !environment.production"
  class="div-esteira-desenvolvimento"
  [style.--bgColor]="(!!environment?.estado_esteira_desenvolvimento?.bgColor ? environment?.estado_esteira_desenvolvimento?.bgColor : '#bb8e40')"
>
  <p>
    Estado de desenvolvimento:<b>  {{environment?.estado_esteira_desenvolvimento?.nome}} </b>
  </p>
</div>
